// Токены дизайн-системы Starling Vision.
//
// ЕДИНСТВЕННЫЙ источник значений — объект `T` ниже: он перенесён ДОСЛОВНО из
// прототипа партнёра (`starling-vision-prototype.jsx`, блок «Design tokens»).
// CSS-модули читают их как переменные `--sv-*`, которые `applyThemeTokens`
// проставляет на <html> при старте приложения (см. main.tsx / setupTests.ts).
// Так у нас нет второй копии палитры в .css и, соответственно, нет дрейфа.
//
// NB: у Vision СВОЙ визуальный язык (прототип партнёра) — это не токены
// Starling Light (design/assets/tokens.css) и не тема Ant Design.

export const T = {
  ink: '#10201D',
  bg: '#F1F3EF',
  card: '#FFFFFF',
  teal: '#1B6E6B',
  tealDeep: '#0E3E3C',
  amber: '#E8A33D',
  mint: '#4FD8C4',
  line: '#DCE0DA',
  sub: '#5C6B65',
  warn: '#C1531F',
  // Производный токен: в прототипе литерал '#EAF6F0' повторяется в тег-пилюлях,
  // счётчиках блоков и ResultBox. Вынесен сюда, чтобы не растекался по CSS.
  mintSoft: '#EAF6F0',
} as const;

export type ThemeToken = keyof typeof T;

/** camelCase → kebab-case для имени CSS-переменной (`tealDeep` → `teal-deep`). */
function toKebab(name: string): string {
  return name.replace(/[A-Z]/g, (ch) => `-${ch.toLowerCase()}`);
}

/** Имя CSS-переменной токена: `tealDeep` → `--sv-teal-deep`. */
export function cssVarName(token: ThemeToken): string {
  return `--sv-${toKebab(token)}`;
}

/** Проставляет все токены как CSS-переменные (по умолчанию — на <html>). */
export function applyThemeTokens(root: HTMLElement = document.documentElement): void {
  for (const [name, value] of Object.entries(T)) {
    root.style.setProperty(cssVarName(name as ThemeToken), value);
  }
}
